import { BedDouble, ChevronDown, ShieldCheck, Star } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export const Trust = () => {
  const { t } = useLang();
  const icons = [<ShieldCheck size={22} key="s" />, <BedDouble size={22} key="b" />, <span className="rupee-icon" key="r">₹</span>];
  return (
    <section className="trust-section" id="about">
      <div className="eyebrow">{t.trust.eyebrow}</div>
      <h2>{t.trust.title}</h2>
      <div className="trust-grid">
        {t.trust.cards.map(([title, copy], i) => (
          <div key={title} data-testid={`trust-card-${i + 1}`}>
            {icons[i]}
            <h3>{title}</h3>
            <p>{copy}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export const Testimonials = () => {
  const { t } = useLang();
  return (
    <section className="testimonials-section" id="reviews">
      <div className="section-heading">
        <div>
          <div className="eyebrow">{t.testimonials.eyebrow}</div>
          <h2>{t.testimonials.title}</h2>
        </div>
        <p>{t.testimonials.note}</p>
      </div>
      <div className="testimonial-grid">
        {t.testimonials.reviews.map(([name, context, quote], i) => (
          <motion.figure
            className="testimonial-card"
            key={name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`testimonial-${i + 1}`}
          >
            <div className="stars" aria-label="5 out of 5 stars">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={14} fill="currentColor" />
              ))}
            </div>
            <blockquote>{quote}</blockquote>
            <figcaption>
              <strong>{name}</strong>
              <small>{context}</small>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};

export const Faq = () => {
  const { t } = useLang();
  return (
    <section className="faq-section" id="faq">
      <div className="eyebrow">{t.faq.eyebrow}</div>
      <h2>{t.faq.title}</h2>
      <div className="faq-list">
        {t.faq.items.map(([question, answer]) => (
          <details key={question} data-testid="faq-item">
            <summary>
              {question}
              <ChevronDown size={18} />
            </summary>
            <p>{answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
};

export const Policies = () => {
  const { t } = useLang();
  return (
    <section className="policy-section" aria-label="Service policies">
      {["privacy", "terms", "cancellation"].map((key) => (
        <article id={key} key={key}>
          <div className="eyebrow">{t.policies[key][0]}</div>
          <h2>{t.policies[key][1]}</h2>
          <p>{t.policies[key][2]}</p>
        </article>
      ))}
    </section>
  );
};
